import React, {Component} from "react";
import {fromJS} from "immutable";
import gql from "graphql-tag";
import {graphql} from "react-apollo";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import PaginatorButton from "../../../components/PaginatorButton";
import AddressInline from "../../../components/AddressInline";
import {Link} from "react-router";
import "./NotificationsList.scss";
import StatusTag from "../../../components/StatusTag";

class ShippingNotificationsList extends Component {

  render() {
    let {loading, error, shippingOrders} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />        
    const data = fromJS(shippingOrders);

    let items = data.get("entries").map((x) => {
      return <Item key={x.get("orderId")} data={x} />
    }).toList();

    return (
      <div className="ShippingNotificationsList NotificationsList">
        {items}
        <PaginatorButton 
            metadata={data.get("metadata")} 
            onNext={this.handleNext.bind(this)}
            />
      </div>
    )
  }

  handleNext(afterId) {
    this.props.data.fetchMore({
      variables: {
        pagination: {
          after: afterId
        }
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return {
          shippingOrders: {
            __typename: prev.shippingOrders.__typename,
            metadata: fetchMoreResult.shippingOrders.metadata,
            entries: [...prev.shippingOrders.entries, ...fetchMoreResult.shippingOrders.entries]
          }
        }
      }
    })
  }

}

const Item = ({data}) => {

  return (
    <div className="item">
      <div className="body">
        <p><Link to={`/shipping/orders/${data.get("orderId")}`}>Shipment</Link> to <AddressInline address={data.get("deliveryAddress")} /> containing <strong>{data.get("nrPackages")} package(s)</strong> was scheduled for pickup by {data.get("courierId")} on <strong>{data.get("pickupDate")}</strong> from <strong>{data.get("warehouseId")}</strong> warehouse.</p>
        <StatusTag color={StatusTag.COLORS.ORANGE}>Pickup Overdue</StatusTag>
        { getTagForStatus(data.get("fulfillmentStatus"), data.get("fulfillmentStatus")) }

        <StatusTag color={StatusTag.COLORS.OUTLINE} text={data.get("jurisdictionId")} />
      </div>
    </div>
  )

}

function getTagForStatus(status, label) {
  switch(status) {
    default:
      return <StatusTag color={StatusTag.COLORS.GREY} text={label} />
  }
}


const QUERY = gql`
  query shippingOrders($filter:ShippingOrderFilters, $pagination:PaginationInput) {
    shippingOrders(filter: $filter, pagination: $pagination) {
      entries {
        orderId
        warehouseId
        jurisdictionId
        nrPackages
        deliveryAddress {
          name
          attName
          addressAddressLine1
          addressAddressLine2
          addressCity
          addressPostcode
          addressStateProvince
          addressCountryName
        }
        pickupDate
        fulfillmentStatus
        courierId
        originalOrderId
        replacedPackageIds {
          packageId
          replacementOrderId
          reason
        }
        hasReplacement
      }
      metadata {
        before
        after
        limit      
      }      
    }
  }
`

const withQuery = graphql(QUERY, {
  options: (props) => ({
    fetchPolicy: "cache-and-network",
    variables: {
      filter: {
        status: "pickup_overdue"
      }
    }
  })
})

export default withQuery(ShippingNotificationsList);